import { gql } from '@apollo/client';

const LOGOUT_MUTATION = gql`
  mutation logout {
    logout {
      isSuccess
      message
    }
  }
`;

export default LOGOUT_MUTATION;
